import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

// Üyelik yenileme sayfası (QR gerektirmez).
// Giriş: telefon + SMS kodu, e-posta + şifre, uygulamadan gelen tek kullanımlık kod (?kod=) ya da mevcut web oturumu.
// Uç'lar: /api/yenile/*, ödeme: /api/posnet/abonelik-uzat
const API = process.env.REACT_APP_API_URL;
const OTURUM_ANAHTARI = "yenileOturum";

const oturumOku = () => {
  try {
    return sessionStorage.getItem(OTURUM_ANAHTARI);
  } catch (_) {
    return null;
  }
};
const oturumYaz = (oturum) => {
  try {
    sessionStorage.setItem(OTURUM_ANAHTARI, oturum);
  } catch (_) {}
};
const oturumSil = () => {
  try {
    sessionStorage.removeItem(OTURUM_ANAHTARI);
  } catch (_) {}
};

async function apiPost(yol, govde) {
  try {
    const response = await fetch(`${API}${yol}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(govde),
    });
    const sonuc = await response.json();
    return { ...sonuc, _status: response.status };
  } catch (_) {
    return { m: "se", mesaj: "Bağlantı hatası. Lütfen tekrar deneyin." };
  }
}

const sureMetni = (sn) =>
  `${String(Math.floor(sn / 60)).padStart(2, "0")}:${String(sn % 60).padStart(2, "0")}`;

const renk = {
  mor: "#667eea",
  yesil: "#10b981",
  sari: "#f59e0b",
  kirmizi: "#ef4444",
  metin: "#1e293b",
  soluk: "#64748b",
  cizgi: "#e2e8f0",
};

const stil = {
  sayfa: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  kart: {
    maxWidth: "480px",
    width: "100%",
    background: "white",
    borderRadius: "24px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    overflow: "hidden",
  },
  baslik: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: "26px 20px",
    textAlign: "center",
    color: "white",
  },
  govde: { padding: "26px 22px" },
  etiket: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#374151",
  },
  girdi: {
    width: "100%",
    height: "52px",
    padding: "14px 16px",
    border: `2px solid ${renk.cizgi}`,
    borderRadius: "12px",
    fontSize: "16px",
    boxSizing: "border-box",
    outline: "none",
    marginBottom: "16px",
  },
  birincilButon: (pasif) => ({
    width: "100%",
    padding: "16px",
    background: pasif ? "#cbd5e1" : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "17px",
    fontWeight: 700,
    cursor: pasif ? "not-allowed" : "pointer",
  }),
  onayKutusu: { display: "flex", gap: "10px", alignItems: "flex-start", fontSize: "14px", color: "#374151", marginBottom: "12px", cursor: "pointer" },
  onayIsareti: { width: "22px", height: "22px", marginTop: "1px", flexShrink: 0 },
  metinButon: {
    background: "none",
    border: "none",
    color: renk.mor,
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    padding: "8px 0",
  },
  sekmeler: {
    display: "flex",
    gap: "8px",
    background: "#f1f5f9",
    borderRadius: "14px",
    padding: "6px",
    marginBottom: "22px",
  },
  sekme: (aktif) => ({
    flex: 1,
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    background: aktif ? "white" : "transparent",
    boxShadow: aktif ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
    color: aktif ? renk.metin : renk.soluk,
    fontWeight: 700,
    fontSize: "15px",
    cursor: "pointer",
  }),
  not: { fontSize: "13px", color: renk.soluk, textAlign: "center", marginTop: "14px" },
};

const mesajRengi = { hata: renk.kirmizi, bilgi: renk.mor, basari: renk.yesil };

export default function Yenile() {
  const [asama, setAsama] = useState("yukleniyor"); // yukleniyor | giris | sms_kod | bilgi
  const [girisTuru, setGirisTuru] = useState("telefon");
  const [telefon, setTelefon] = useState("");
  const [kod, setKod] = useState("");
  const [email, setEmail] = useState("");
  const [sifre, setSifre] = useState("");
  const [kalanSn, setKalanSn] = useState(0);
  const [bilgi, setBilgi] = useState(null);
  // İlk kayıttaki gibi: sözleşme + KVKK & Gizlilik zorunlu (sunucu da kaydeder), reklam izni isteğe bağlı (mevcut tercihle gelir)
  const [sozlesmeOnay, setSozlesmeOnay] = useState(false);
  const [gizlilikOnay, setGizlilikOnay] = useState(false);
  const [reklamIzni, setReklamIzni] = useState(false);
  const onaylarTamam = sozlesmeOnay && gizlilikOnay;
  const [islemde, setIslemde] = useState(false);
  const [mesaj, setMesaj] = useState(null);
  const [hediyeKoduAcik, setHediyeKoduAcik] = useState(false);
  const [hediyeKodu, setHediyeKodu] = useState("");

  const bilgiYukle = useCallback(async (oturum) => {
    const r = await apiPost("/api/yenile/oturum", { oturum });
    if (r.m === "basarili") {
      setBilgi(r);
      // Reklam izni kutusu her yenilemede işaretsiz gelir: izin önceden işaretli kutuyla alınmaz, üye kendisi işaretler
      setAsama("bilgi");
      return true;
    }
    oturumSil();
    return false;
  }, []);

  const oturumuKaydetVeYukle = useCallback(
    async (oturum) => {
      oturumYaz(oturum);
      if (!(await bilgiYukle(oturum))) {
        setMesaj({ tip: "hata", metin: "Üyelik bilgileri alınamadı. Lütfen tekrar giriş yapın." });
        setAsama("giris");
      }
    },
    [bilgiYukle],
  );

  // Açılışta sırasıyla: uygulamadan gelen kod → kayıtlı oturum → web'deki mevcut oturum → giriş ekranı
  useEffect(() => {
    (async () => {
      const kodParametresi = new URLSearchParams(window.location.search).get("kod");
      if (kodParametresi) {
        // Kod adres çubuğunda / geçmişte kalmasın
        window.history.replaceState(null, "", window.location.pathname);
        const r = await apiPost("/api/yenile/kod-ile-giris", { kod: kodParametresi });
        if (r.m === "basarili") return oturumuKaydetVeYukle(r.oturum);
        setMesaj({ tip: "hata", metin: r.mesaj });
      }

      const kayitliOturum = oturumOku();
      if (kayitliOturum && (await bilgiYukle(kayitliOturum))) return;

      const webTokeni = Cookies.get("token");
      if (webTokeni) {
        const r = await apiPost("/api/yenile/web-oturumu", { token: webTokeni });
        if (r.m === "basarili") return oturumuKaydetVeYukle(r.oturum);
      }
      setAsama("giris");
    })();
  }, [bilgiYukle, oturumuKaydetVeYukle]);

  // SMS kodunun kalan süresi
  useEffect(() => {
    if (asama !== "sms_kod" || kalanSn <= 0) return undefined;
    const t = setTimeout(() => setKalanSn((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [asama, kalanSn]);

  const kodGonder = async () => {
    setIslemde(true);
    setMesaj(null);
    const r = await apiPost("/api/yenile/sms-kodu-gonder", { telefon });
    setIslemde(false);
    if (r.m === "basarili") {
      setKod("");
      setKalanSn(r.gecerlilikSn || 180);
      setAsama("sms_kod");
      setMesaj({ tip: "bilgi", metin: r.mesaj });
    } else {
      setMesaj({ tip: "hata", metin: r.mesaj || "Kod gönderilemedi." });
    }
  };

  const kodDogrula = async () => {
    setIslemde(true);
    setMesaj(null);
    const r = await apiPost("/api/yenile/sms-kodu-dogrula", { telefon, kod });
    setIslemde(false);
    if (r.m === "basarili") return oturumuKaydetVeYukle(r.oturum);
    setMesaj({ tip: "hata", metin: r.mesaj || "Kod doğrulanamadı." });
    if (r.m === "kod_gecersiz") setKalanSn(0);
    return undefined;
  };

  const epostaGiris = async () => {
    setIslemde(true);
    setMesaj(null);
    const r = await apiPost("/api/yenile/eposta-giris", { email, sifre });
    setIslemde(false);
    if (r.m === "basarili") {
      setSifre("");
      return oturumuKaydetVeYukle(r.oturum);
    }
    setMesaj({ tip: "hata", metin: r.mesaj || "Giriş yapılamadı." });
    return undefined;
  };

  const onayGovdesi = () => ({ sozlesmeOnayi: sozlesmeOnay, gizlilikOnayi: gizlilikOnay, reklamIzni });
  const onayEksikMesaji = () =>
    setMesaj({ tip: "hata", metin: "Devam etmek için üyelik sözleşmesini ve KVKK & Gizlilik Politikası'nı onaylayın." });

  const odemeyeGec = async () => {
    if (!onaylarTamam) {
      onayEksikMesaji();
      return;
    }
    setIslemde(true);
    setMesaj(null);
    // Sayfada gösterilen ücret de gönderilir: sayfa açıkken ücret değiştiyse sunucu oturum açmaz, yeni tutar gösterilir
    const r = await apiPost("/api/posnet/abonelik-uzat", { token: oturumOku(), gosterilenUcretKurus: bilgi.ucretKurus, ...onayGovdesi() });
    if (r.success && r.redirectUrl) {
      window.location.href = r.redirectUrl;
      return;
    }
    setIslemde(false);
    if (r.kod === "ucret_degisti") {
      setBilgi((b) => ({ ...b, ucretKurus: r.kurus, ucretTl: r.tl }));
      setMesaj({ tip: "hata", metin: r.message });
      return;
    }
    if (r._status === 401) {
      oturumSil();
      setAsama("giris");
      setMesaj({ tip: "hata", metin: "Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın." });
      return;
    }
    setMesaj({ tip: "hata", metin: r.message || r.mesaj || "Ödeme başlatılamadı." });
  };

  const hediyeKoduylaYenile = async () => {
    if (!onaylarTamam) {
      onayEksikMesaji();
      return;
    }
    setIslemde(true);
    setMesaj(null);
    const r = await apiPost("/api/yenile/hediye-kodu", { oturum: oturumOku(), kod: hediyeKodu, ...onayGovdesi() });
    setIslemde(false);
    if (r.m === "basarili") {
      setHediyeKodu("");
      setHediyeKoduAcik(false);
      setSozlesmeOnay(false);
      setGizlilikOnay(false);
      await bilgiYukle(oturumOku());
      setMesaj({ tip: "basari", metin: r.mesaj });
      return;
    }
    if (r.m === "oturum_gecersiz") {
      oturumSil();
      setAsama("giris");
    }
    setMesaj({ tip: "hata", metin: r.mesaj || "Hediye kodu kullanılamadı." });
  };

  const cikis = () => {
    oturumSil();
    setBilgi(null);
    setSozlesmeOnay(false);
    setGizlilikOnay(false);
    setReklamIzni(false);
    setMesaj(null);
    setAsama("giris");
  };

  const durumKutusu = () => {
    if (!bilgi) return null;
    const kutular = {
      aktif: {
        renk: renk.yesil,
        zemin: "#ecfdf5",
        metin: `Üyeliğiniz ${bilgi.bitisMetin} tarihine kadar geçerli (${bilgi.kalanGun} gün kaldı).`,
      },
      ek_sure: {
        renk: renk.sari,
        zemin: "#fffbeb",
        metin: `Üyeliğiniz ${bilgi.bitisMetin} tarihinde sona erdi. Ek süre içindesiniz, hemen yenileyin.`,
      },
      suresi_doldu: {
        renk: renk.kirmizi,
        zemin: "#fef2f2",
        metin: bilgi.bitisMetin
          ? `Üyeliğinizin süresi ${bilgi.bitisMetin} tarihinde doldu. Yenileyerek kullanmaya devam edebilirsiniz.`
          : "Üyelik bitiş tarihiniz bulunamadı. Yenileyerek kullanmaya devam edebilirsiniz.",
      },
    };
    const k = kutular[bilgi.durum] || kutular.suresi_doldu;
    return (
      <div
        style={{
          background: k.zemin,
          border: `2px solid ${k.renk}`,
          borderRadius: "14px",
          padding: "14px 16px",
          color: renk.metin,
          fontSize: "15px",
          lineHeight: 1.5,
          marginBottom: "18px",
        }}
      >
        {k.metin}
      </div>
    );
  };

  return (
    <div style={stil.sayfa}>
      <div style={stil.kart}>
        <div style={stil.baslik}>
          <h2 style={{ margin: "0 0 6px", fontSize: "clamp(22px, 5vw, 28px)", fontWeight: 700 }}>
            Üyelik Yenileme
          </h2>
          <p style={{ margin: 0, fontSize: "14px", opacity: 0.9 }}>NM Universal Team</p>
        </div>

        <div style={stil.govde}>
          {mesaj && (
            <div
              role="alert"
              style={{
                border: `1px solid ${mesajRengi[mesaj.tip]}`,
                color: mesajRengi[mesaj.tip],
                background: "#fff",
                borderRadius: "10px",
                padding: "10px 14px",
                fontSize: "14px",
                marginBottom: "16px",
              }}
            >
              {mesaj.metin}
            </div>
          )}

          {asama === "yukleniyor" && (
            <p style={{ textAlign: "center", color: renk.soluk }}>Yükleniyor…</p>
          )}

          {asama === "giris" && (
            <>
              <div style={stil.sekmeler}>
                <button
                  type="button"
                  style={stil.sekme(girisTuru === "telefon")}
                  onClick={() => {
                    setGirisTuru("telefon");
                    setMesaj(null);
                  }}
                >
                  📱 Telefon
                </button>
                <button
                  type="button"
                  style={stil.sekme(girisTuru === "eposta")}
                  onClick={() => {
                    setGirisTuru("eposta");
                    setMesaj(null);
                  }}
                >
                  ✉️ E-posta
                </button>
              </div>

              {girisTuru === "telefon" ? (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    kodGonder();
                  }}
                >
                  <label style={stil.etiket} htmlFor="yenile-telefon">
                    Cep telefonu numaranız
                  </label>
                  <input
                    id="yenile-telefon"
                    type="tel"
                    inputMode="tel"
                    autoComplete="tel"
                    placeholder="05xx xxx xx xx"
                    value={telefon}
                    onChange={(e) => setTelefon(e.target.value)}
                    style={stil.girdi}
                  />
                  <button type="submit" disabled={islemde || telefon.trim().length < 10} style={stil.birincilButon(islemde || telefon.trim().length < 10)}>
                    {islemde ? "Gönderiliyor…" : "Kod Gönder"}
                  </button>
                  <p style={stil.not}>Yurt dışı numaranız varsa E-posta sekmesini kullanın.</p>
                </form>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    epostaGiris();
                  }}
                >
                  <label style={stil.etiket} htmlFor="yenile-eposta">
                    E-posta adresiniz
                  </label>
                  <input
                    id="yenile-eposta"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={stil.girdi}
                  />
                  <label style={stil.etiket} htmlFor="yenile-sifre">
                    Uygulama şifreniz
                  </label>
                  <input
                    id="yenile-sifre"
                    type="password"
                    autoComplete="current-password"
                    value={sifre}
                    onChange={(e) => setSifre(e.target.value)}
                    style={stil.girdi}
                  />
                  <button type="submit" disabled={islemde || !email || !sifre} style={stil.birincilButon(islemde || !email || !sifre)}>
                    {islemde ? "Giriş yapılıyor…" : "Giriş Yap"}
                  </button>
                  <p style={stil.not}>
                    Şifrenizi mi unuttunuz? <Link to="/iletisim">Destek ekibimize yazın</Link>.
                  </p>
                </form>
              )}
            </>
          )}

          {asama === "sms_kod" && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                kodDogrula();
              }}
            >
              <label style={stil.etiket} htmlFor="yenile-kod">
                {telefon} numarasına gönderilen 4 haneli kod
              </label>
              <input
                id="yenile-kod"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={4}
                value={kod}
                onChange={(e) => setKod(e.target.value.replace(/\D/g, "").slice(0, 4))}
                style={{ ...stil.girdi, fontSize: "26px", letterSpacing: "12px", textAlign: "center", height: "64px" }}
              />
              <button type="submit" disabled={islemde || kod.length !== 4} style={stil.birincilButon(islemde || kod.length !== 4)}>
                {islemde ? "Doğrulanıyor…" : "Doğrula"}
              </button>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                <button
                  type="button"
                  style={stil.metinButon}
                  onClick={() => {
                    setAsama("giris");
                    setMesaj(null);
                  }}
                >
                  ← Numarayı değiştir
                </button>
                {kalanSn > 0 ? (
                  <span style={{ fontSize: "14px", color: renk.soluk }}>Kod {sureMetni(kalanSn)} geçerli</span>
                ) : (
                  <button type="button" style={stil.metinButon} disabled={islemde} onClick={kodGonder}>
                    Kodu tekrar gönder
                  </button>
                )}
              </div>
            </form>
          )}

          {asama === "bilgi" && bilgi && (
            <>
              <p style={{ fontSize: "18px", fontWeight: 700, color: renk.metin, margin: "0 0 14px" }}>
                Merhaba {bilgi.isim} {bilgi.soyisim}
              </p>
              {durumKutusu()}

              {/* Yenileme penceresi sunucuda: bitişe 30 günden fazla varsa yenilenebilir=false gelir ve engelMesaji gösterilir. */}
              {bilgi.yenilenebilir ? (
                <>
                  <div style={{ border: `1px solid ${renk.cizgi}`, borderRadius: "14px", padding: "14px 16px", marginBottom: "16px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                      <span style={{ color: renk.soluk }}>Yıllık üyelik ücreti</span>
                      <strong>{bilgi.ucretTl.toLocaleString("tr-TR")} ₺</strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ color: renk.soluk }}>Yeni bitiş tarihi</span>
                      <strong>{bilgi.yeniBitisMetin}</strong>
                    </div>
                  </div>

                  {/* Kayıt formundaki onaylarla aynı: sözleşme ve KVKK zorunlu, reklam izni isteğe bağlı */}
                  <label style={stil.onayKutusu}>
                    <input
                      type="checkbox"
                      checked={reklamIzni}
                      onChange={(e) => setReklamIzni(e.target.checked)}
                      style={stil.onayIsareti}
                    />
                    <span>E-posta yoluyla bildirim ve reklam kampanyası almak istiyorum.</span>
                  </label>
                  <label style={stil.onayKutusu}>
                    <input
                      type="checkbox"
                      checked={sozlesmeOnay}
                      onChange={(e) => setSozlesmeOnay(e.target.checked)}
                      style={stil.onayIsareti}
                    />
                    <span>
                      <Link to="/gizlilik_politikasi/uyelik_satis_sozlesmesi" target="_blank" rel="noopener noreferrer">
                        Üyelik & Satış Sözleşmesi
                      </Link>
                      'ni okudum ve kabul ediyorum. *
                    </span>
                  </label>
                  <label style={{ ...stil.onayKutusu, marginBottom: "18px" }}>
                    <input
                      type="checkbox"
                      checked={gizlilikOnay}
                      onChange={(e) => setGizlilikOnay(e.target.checked)}
                      style={stil.onayIsareti}
                    />
                    <span>
                      <Link to="/gizlilik_politikasi" target="_blank" rel="noopener noreferrer">
                        KVKK & Gizlilik Politikası
                      </Link>
                      'nı okudum ve kabul ediyorum. *
                    </span>
                  </label>

                  <button type="button" disabled={islemde || !onaylarTamam} onClick={odemeyeGec} style={stil.birincilButon(islemde || !onaylarTamam)}>
                    {islemde ? "Ödeme sayfasına yönlendiriliyor…" : `💳 ${bilgi.ucretTl.toLocaleString("tr-TR")} ₺ Kartla Öde`}
                  </button>

                  <div style={{ marginTop: "16px", borderTop: `1px solid ${renk.cizgi}`, paddingTop: "12px" }}>
                    {!hediyeKoduAcik ? (
                      <button type="button" style={stil.metinButon} onClick={() => setHediyeKoduAcik(true)}>
                        🎁 Hediye kodum var
                      </button>
                    ) : (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          hediyeKoduylaYenile();
                        }}
                      >
                        <label style={stil.etiket} htmlFor="yenile-hediye-kodu">
                          Hediye kodunuz
                        </label>
                        <input
                          id="yenile-hediye-kodu"
                          type="text"
                          autoComplete="off"
                          autoCapitalize="characters"
                          maxLength={20}
                          value={hediyeKodu}
                          onChange={(e) => setHediyeKodu(e.target.value.toUpperCase().replace(/\s/g, ""))}
                          style={{ ...stil.girdi, letterSpacing: "3px" }}
                        />
                        <button
                          type="submit"
                          disabled={islemde || !onaylarTamam || hediyeKodu.length < 6}
                          style={stil.birincilButon(islemde || !onaylarTamam || hediyeKodu.length < 6)}
                        >
                          {islemde ? "Kontrol ediliyor…" : "🎁 Hediye Koduyla Yenile"}
                        </button>
                      </form>
                    )}
                  </div>
                </>
              ) : (
                <div style={{ background: "#f8fafc", border: `1px solid ${renk.cizgi}`, borderRadius: "14px", padding: "14px 16px", color: renk.metin, fontSize: "14px", lineHeight: 1.5 }}>
                  {bilgi.engelMesaji}
                  {bilgi.durum === "aktif" && (
                    <div style={{ marginTop: "8px", color: renk.soluk }}>
                      Bitişe 30 gün kala size hatırlatma göndereceğiz.
                    </div>
                  )}
                </div>
              )}

              <div style={{ textAlign: "center", marginTop: "12px" }}>
                <button type="button" style={stil.metinButon} onClick={cikis}>
                  Farklı hesapla giriş yap
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
